export const GAME_TYPE = 'GAME_TYPE';
export const ADD_EMERSION_MESSAGE = 'ADD_EMERSION_MESSAGE';
export const REMOVE_EMISION_MESSAGE = 'REMOVE_EMISION_MESSAGE';
export const REMOVE_ALL_EMISION = 'REMOVE_ALL_EMISION';
export const CONNECTION_STATUS = 'CONNECTION_STATUS';
export const CONTROLLER_STATUS = 'CONTROLLER_STATUS';
export const ADD_USER_DATA = 'ADD_USER_DATA';
export const ADMIN_LINK = 'ADMIN_LINK';